import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

import { collectionQueryKeys } from "./collectionQueryKeys";
import { getAccessQueryKey } from "./useCollectionAccess";

interface DeleteCollectionVariables {
  collectionId: string;
  orgId: string;
  resourceOwnerId: string;
}

export function useDeleteCollection() {
  const { collections } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteCollectionVariables>({
    mutationFn: ({ collectionId, resourceOwnerId }) =>
      collections.deleteCollection(collectionId, { resourceOwnerId }),
    onSuccess: (_, { collectionId, orgId }) => {
      void queryClient.invalidateQueries({
        queryKey: collectionQueryKeys.detail(collectionId),
      });
      void queryClient.invalidateQueries({
        queryKey: collectionQueryKeys.lists(orgId),
      });
      queryClient.removeQueries({ queryKey: getAccessQueryKey(collectionId) });
    },
  });
}
